import { useStaticQuery, graphql } from "gatsby"

export const useMenuApplication = locale => {
  const menu = useStaticQuery(graphql`
    query UseApplicationMenuQuery {
      allDatoCmsMenuApplication(
        filter: { root: { eq: true } }
        sort: { fields: [position], order: ASC }
      ) {
        nodes {
          id
          root
          locale
          title
          position
          application {
            ... on DatoCmsApplicationPage {
              id

              _allSlugLocales {
                locale
                value
              }
              title
              position
              slug
              model {
                apiKey
              }
            }
            ... on DatoCmsCategoryPage {
              id
              application {
                title
                id
                slug
                _allSlugLocales {
                  locale
                  value
                }
              }
              _allSlugLocales {
                locale
                value
              }
              slug
              subtitle
              title
              model {
                apiKey
              }
            }
            ... on DatoCmsProductPage {
              id
              _allSlugLocales {
                locale
                value
              }
              title
              slug
              model {
                apiKey
              }
            }
            ... on DatoCmsPage {
              id
              title
              slug
              root
              _allSlugLocales {
                locale
                value
              }
              treeParent {
                slug
                root
                _allSlugLocales {
                  locale
                  value
                }
                treeParent {
                  slug
                  root
                  _allSlugLocales {
                    locale
                    value
                  }
                }
              }
              model {
                apiKey
              }
            }
            ... on DatoCmsLink {
              id
              url
              openInNewWindow
              model {
                apiKey
              }
            }
          }
          treeChildren {
            id
            locale
            title
            position
            application {
              ... on DatoCmsApplicationPage {
                id
                _allSlugLocales {
                  locale
                  value
                }
                title
                position
                slug
                model {
                  apiKey
                }
              }
              ... on DatoCmsCategoryPage {
                id
                application {
                  title
                  id
                  slug
                  _allSlugLocales {
                    locale
                    value
                  }
                }
                _allSlugLocales {
                  locale
                  value
                }
                slug
                subtitle
                title
                model {
                  apiKey
                }
              }
              ... on DatoCmsProductPage {
                id
                _allSlugLocales {
                  locale
                  value
                }
                title
                slug
                model {
                  apiKey
                }
              }
              ... on DatoCmsPage {
                id
                title
                slug
                root
                _allSlugLocales {
                  locale
                  value
                }
                treeParent {
                  slug
                  root
                  _allSlugLocales {
                    locale
                    value
                  }
                  treeParent {
                    slug
                    root
                    _allSlugLocales {
                      locale
                      value
                    }
                  }
                }
                model {
                  apiKey
                }
              }
              ... on DatoCmsLink {
                id
                url
                openInNewWindow
                model {
                  apiKey
                }
              }
            }
            treeChildren {
              id
              locale
              title
              position
              application {
                ... on DatoCmsApplicationPage {
                  id
                  _allSlugLocales {
                    locale
                    value
                  }
                  title
                  position
                  slug
                  model {
                    apiKey
                  }
                }
                ... on DatoCmsCategoryPage {
                  id
                  application {
                    title
                    id
                    slug
                    _allSlugLocales {
                      locale
                      value
                    }
                  }
                  _allSlugLocales {
                    locale
                    value
                  }
                  slug
                  subtitle
                  title
                  model {
                    apiKey
                  }
                }
                ... on DatoCmsProductPage {
                  id
                  _allSlugLocales {
                    locale
                    value
                  }
                  title
                  slug
                  model {
                    apiKey
                  }
                }
                ... on DatoCmsPage {
                  id
                  title
                  slug
                  root
                  _allSlugLocales {
                    locale
                    value
                  }
                  treeParent {
                    slug
                    root
                    _allSlugLocales {
                      locale
                      value
                    }
                    treeParent {
                      slug
                      root
                      _allSlugLocales {
                        locale
                        value
                      }
                    }
                  }
                  model {
                    apiKey
                  }
                }
                ... on DatoCmsLink {
                  id
                  url
                  openInNewWindow
                  model {
                    apiKey
                  }
                }
              }
              treeChildren {
                id
                locale
                title
                position
                application {
                  ... on DatoCmsApplicationPage {
                    id
                    _allSlugLocales {
                      locale
                      value
                    }
                    title
                    position
                    slug
                    model {
                      apiKey
                    }
                  }
                  ... on DatoCmsCategoryPage {
                    id
                    application {
                      title
                      id
                      slug
                      _allSlugLocales {
                        locale
                        value
                      }
                    }
                    _allSlugLocales {
                      locale
                      value
                    }
                    slug
                    subtitle
                    title
                    model {
                      apiKey
                    }
                  }
                  ... on DatoCmsProductPage {
                    id
                    _allSlugLocales {
                      locale
                      value
                    }
                    title
                    slug
                    model {
                      apiKey
                    }
                  }
                  ... on DatoCmsPage {
                    id
                    title
                    slug
                    root
                    _allSlugLocales {
                      locale
                      value
                    }
                    treeParent {
                      slug
                      root
                      _allSlugLocales {
                        locale
                        value
                      }
                      treeParent {
                        slug
                        root
                        _allSlugLocales {
                          locale
                          value
                        }
                      }
                    }
                    model {
                      apiKey
                    }
                  }
                  ... on DatoCmsLink {
                    id
                    url
                    openInNewWindow
                    model {
                      apiKey
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  // Funzione ricorsiva per ordinare tutti i livelli dell'albero per position
  const sortTreeByPosition = items => {
    if (!items || !Array.isArray(items)) return items

    return items
      .sort((a, b) => a.position - b.position)
      .map(item => ({
        ...item,
        treeChildren: sortTreeByPosition(item.treeChildren),
      }))
  }

  const currentLocaleMenu = menu.allDatoCmsMenuApplication.nodes
    .filter(menu => menu.locale === locale)
    .map(menu => ({
      ...menu,
      treeChildren: sortTreeByPosition(menu.treeChildren),
    }))

  return currentLocaleMenu
}
